import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'
import type { Route } from '@/utils/enroutes'

import { Line } from '@/components/elements/Line'

export const SiteMapLink = ({ name, path, subdirectories }: Route) => {
  return (
    <Wrapper>
      <Link href={path} passHref>
        <a>
          <h3>{name}</h3>
        </a>
      </Link>
      <StyledLine color="grey" weight={1} direction="horizon" />
      <SubLinks>
        {subdirectories.map(({ name, path, isExternalLink }) =>
          isExternalLink ? (
            <a
              key={name}
              target="_blank"
              rel="noopener noreferrer"
              href={path}
              className="external-link"
            >
              {name}
            </a>
          ) : (
            <Link key={name} href={path} passHref>
              <a>{name}</a>
            </Link>
          )
        )}
      </SubLinks>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 480px;

  a {
    width: 100%;
  }

  h3 {
    font-size: 28px;
    line-height: 38px;
    font-weight: bold;
    text-align: left;
    letter-spacing: 1.68px;
    color: ${theme.colors.trialBlue};
  }

  @media screen and (max-width: 1047px) {
    width: 100%;

    h3 {
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 1.2px;
    }
  }
`

const StyledLine = styled(Line)`
  width: 100%;
  margin: 12px auto 40px;

  @media screen and (max-width: 1047px) {
    margin: 8px auto 22px;
  }
`

const SubLinks = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  a {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.32px;
    color: ${theme.colors.trialBlue};

    &:hover {
      text-decoration: underline;
      color: #3786c7;
    }
  }

  .external-link {
    &:after {
      content: '';
      background: url('/images/external-link-trialblue.svg') no-repeat;
      width: 12px;
      height: 12px;
      margin-left: 6px;
      display: inline-block;
    }

    &:hover:after {
      background: url('/images/external-link-hoverblue.svg') no-repeat;
    }
  }

  @media screen and (max-width: 1047px) {
    row-gap: 12px;

    a {
      font-size: 15px;
      line-height: 18px;
      letter-spacing: 0.6px;
    }
  }
`
